import { useEffect, useState } from "react";
import styles from "./MenuAccordion.module.css";
// import arrow from "../../../assets/images/arrow.png";
import "../../../App.css";
import { getPreLoginPageAction } from "redux-container/pre-login-page-management-redux/PreLoginPageManagementRedux";
import { useDispatch, useSelector } from "react-redux";
import PromisesDetailWrapper from "components/promisesDetailWrapper/promisesDetailWrapper";
// import liquidity_new from "../../../assets/images/liquidity_new.png";
// import security_new from "../../../assets/images/security_new.png";
// import transparency_new from "../../../assets/images/transparency_new.png";
// import wealth_new from "../../../assets/images/wealth_new.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Constants } from "constants/Constants";
import MediaAssets from "assets";

const actionDispatch = (dispatch: any) => {
  return {
    getPreLoginPageDetails: (params: any) =>
      dispatch(getPreLoginPageAction.getPreLoginPagesRequest(params)),
    getProjectContentList: (params: any) =>
      dispatch(getPreLoginPageAction.getProjectContentsRequest(params)),
    setPagemanagementState: (key: any, value: any) =>
      dispatch(getPreLoginPageAction.setPageState(key, value)),
  };
};
const MenuAccordion = (prop: any) => {
  const ASSETS_BASE_URL = Constants.ASSETS_BASE_URL;
  const ASSETS_IMAGE_PATH = Constants.ASSETS_IMAGE_PATH;

  const [stateOne, setStateOne] = useState(false);
  const [stateTwo, setstateTwo] = useState(false);
  const [stateThree, setStateThree] = useState(false);
  const [stateFour, setStateFour] = useState(false);
  const [ind, setInd] = useState(0);
  const [showPromiseModal, setShowPromiseModal] = useState(false);
  const [promiseDetails, setPromiseDetails] = useState("");
  const { getPreLoginPageDetails } = actionDispatch(useDispatch());
  const icons = [
    MediaAssets.security_new,
    MediaAssets.liquidity_new,
    MediaAssets.transparency_new,
    MediaAssets.wealth_new,
  ];

  useEffect(() => {
    const menubackiconURL = `${ASSETS_BASE_URL}${ASSETS_IMAGE_PATH}/menubackicon.png`;
    document.documentElement.style.setProperty(
      "--menubackicon",
      `url(${menubackiconURL})`
    );
  }, []);

  const promises = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData?.homePagesOrPromises;
  });
  const promisesHeading = useSelector((state: any) => {
    return state?.preLoginPageManagement?.pageData?.page?.promisesHeading;
  });
  console.log("promises", promises);

  const toogleClassOne = (index: any) => {
    setInd(index);
    if (stateOne === true) {
      setStateOne(false);
    } else {
      setStateOne(true);
    }
  };

  const toogleClassTwo = () => {
    if (stateTwo === true) {
      setstateTwo(false);
    } else {
      setstateTwo(true);
    }
  };

  const toogleClassThree = () => {
    if (stateThree === true) {
      setStateThree(false);
    } else {
      setStateThree(true);
    }
  };

  const toogleClassFour = (index: any) => {};
  function compareByPriority(item1: any, item2: any) {
    return item1.priority - item2.priority;
  }
  promises?.sort(compareByPriority);

  return (
    <>
      <div className={styles["menuPageCon"]}>
        <div className={styles.logoWithHeader}>
          {/* <img src={exploreImg} alt="menuimg" /> */}
          <div className={styles["title"]}>{promisesHeading}</div>
        </div>

        {/* for desktop */}
        <div className={styles.forDesktop}>
          {showPromiseModal && (
            <PromisesDetailWrapper
              promiseDetails={promiseDetails}
              setShowPromiseModal={setShowPromiseModal}
            />
          )}
          <div className={styles.wrapper}>
            {promises &&
              promises?.map((promise: any, index: any) => {
                if (promise?.status !== "1001") {
                  return;
                }
                return (
                  <>
                    <div
                      key={index}
                      className={styles.openMenu}
                      onClick={() => {
                        setShowPromiseModal(true);
                        setPromiseDetails(promise);
                      }}
                    >
                      <div className={styles.inside}>
                        <div className={styles.menu}>
                          <div className={styles.shieldWithTitle}>
                            <LazyLoadImage
                              src={icons[index]}
                              alt="Landing page"
                              className={styles[`shield${index}`]}
                              style={{
                                marginLeft:
                                  index === 2
                                    ? "-12px"
                                    : index === 1
                                    ? "-10px"
                                    : index === 3
                                    ? "-8px"
                                    : "",
                                width: "100px",
                                lineHeight: 0,
                                display: "flex",
                              }}
                              id={`shield${index}`}
                            />
                            <p
                              className={`text${index}`}
                              style={{
                                marginLeft:
                                  index === 1
                                    ? "-12px"
                                    : index === 3
                                    ? "-8px"
                                    : "",
                                fontSize: "20px",
                                lineHeight: 0,
                              }}
                            >
                              {promise.name}
                            </p>
                          </div>

                          <div
                            className={styles.descp}
                            style={{ fontSize: "16px" }}
                          >
                            {promise.shortDescription}
                          </div>
                          <div className={styles.arrowWrapper}>
                            <LazyLoadImage
                              src={MediaAssets.arrow}
                              alt="Landing page"
                              width={24}
                              onClick={() => {
                                toogleClassOne(index);
                              }}
                              className={`arrow${index}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        </div>

        {/* end of desktop Design */}
        <div className={styles.forMobile}>
          <div className={styles.wrapper}>
            {promises &&
              promises.map((promise: any, index: number) => {
                return (
                  <>
                    <div
                      key={index}
                      className={
                        stateOne && index === ind
                          ? styles.openMenu
                          : styles.beforeAfter
                      }
                    >
                      <div className={styles.inside}>
                        <div className={styles.menu}>
                          <div className={styles.shieldWithTitle}>
                            <LazyLoadImage
                              src={icons[index]}
                              alt="Landing page"
                              className={`shield${index}`}
                              id={`shield${index}`}
                              width={40}
                              style={{
                                marginLeft:
                                  index === 2
                                    ? "-85px"
                                    : ` ${index === 3 ? "8px" : ""}`,
                                width: "100px",
                                lineHeight: 0,
                              }}
                            />
                            <p
                              className={`text${index}`}
                              style={{
                                marginLeft: index === 1 ? "10px" : "",
                                fontSize: "20px",
                                lineHeight: 0,
                              }}
                            >
                              {promise.name}
                            </p>
                          </div>

                          <div
                            className={styles.descp}
                            style={{
                              fontSize: "16px",
                              fontFamily: "Futura Md BT",
                            }}
                          >
                            {promise.shortDescription}
                          </div>
                          <div className={styles.arrowWrapper}>
                            <LazyLoadImage
                              src={MediaAssets.arrow}
                              alt="Landing page"
                              width={24}
                              onClick={() => {
                                toogleClassOne(index);
                              }}
                              className={`arrow${index}`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuAccordion;
